import { defineMessages } from 'react-intl';

export default defineMessages({
  caption: '{symbol} Reserve Overview',

  utilizationRate: 'Utilization rate',
  availableLiquidity: 'Available liquidity',
  depositAPY: 'Deposit APY',
  depositAPR: 'Deposit APR',
  canBeUsedAsCollateral: 'Can be used as collateral',
  no: 'No',
  yes: 'Yes',
  assetPrice: 'Asset price',
  maximumLTV: 'Maximum LTV',
  liquidationThreshold: 'Liquidation threshold',
  liquidationPenalty: 'Liquidation penalty',

  stableAPY: 'Stable borrow APY',
  variableAPY: 'Variable borrow APY',
});
